import axios from 'axios';
import { useDispatch } from 'react-redux';
import { define } from '../data/globals'

export function useProductPics() {
    // Redux
    const dispath = useDispatch()
    
    // Получение списка изображений (по id товара)
    async function getProductPics(id) {
        if(!id) {
            console.log('\n Ошибка. В функцию getProductPics не передан id (обязательный параметр) \n ');
            alert('Ошибка (см. консроль)');
            return
        }

        try {
            const response = await axios({
                method: 'get',
                url: define.pathToAPI + '/multiupload/getPictures.php',
                params: {
                    id: id,
                },
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })// axios

            // проверка ответа от getPictures.php
            if(response.data.pictures) {
                dispath({ type: 'SetPicsInDB', picsInDB: response.data.pictures })
            } else {
                dispath({ type: 'SetPicsInDB', picsInDB: [] })
            }
        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при получении списка изображений товара.\nКод: 400 - Некорректный ID\n(см. getPictures.php)')
                alert('Ошибка (код: 400) (см.  консоль)')
            } else {
                console.log(e)
                alert('Ошибка:\n' + e)
            }
        } // try

    } // getProductPics


    return getProductPics
}